import { httpMethod, useApi } from './useApi';
export const useCreateFlow = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flows',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetFlows = (queryParams) => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flows',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: queryParams,
    });
    const responseData = data;
    return { call, data: responseData, error, ...rest };
};
export const useUpdateFlow = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flows',
        httpMethod: httpMethod.PUT,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useDeleteFlow = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flows',
        httpMethod: httpMethod.DELETE,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetFlowPredefinedSteps = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flows/steps',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: {},
    });
    const responseData = data;
    return { call, data: responseData, error, ...rest };
};
export const useTestFlow = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flows/test',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
